module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_13.499c4128.jpg";